export const ACTUALIZAR_LIST_TEMPLATES_PRODUCCION = "ACTUALIZAR_LIST_TEMPLATES_PRODUCCION";
export const MODIFICAR_TEMPLATE_PRODUCCION = "MODIFICAR_TEMPLATE_PRODUCCION";
export const AGREGAR_TEMPLATE_PRODUCCION = "AGREGAR_TEMPLATE_PRODUCCION";
export const ELIMINAR_TEMPLATE_PRODUCCION = "ELIMINAR_TEMPLATE_PRODUCCION";
